module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-2-094aefd30658b5a5a1f910dd999572de.jpg";